require('./contractLoanDaySelector.scss');

const PropTypes = require('prop-types');

//@vendor
const React = require('react');
const moment = require('moment');

//@commons
const { OKMessage } = require('commonsComponents/OKMessage');

//@components
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;

// @constants
const { PAYMENT_DAY_END_OF_MONTH, PAYMENT_DAY_OTHER } = require('../../../loansConstants/index').contractEasyLoan;

const ContractLoanDaySelector = props => {
    const { paymentDaySelected, firstRadioButtonLabel,
        secondRadioButtonLabel, message, onPaymentDayChange } = props;
    const currentDayNumber = moment().date();
    const radioButtonTitle = formatText('contractLoanDaySelector-radioButtonSectionTitle');
    const firstRadioButton = formatText(firstRadioButtonLabel);
    const secondRadioButton = formatText(secondRadioButtonLabel, [currentDayNumber]);

    const messageContainer = message ? (
        <div className="contract-loan-day-selector__radio-message">
            <OKMessage type="informative">
                <FormattedText value={message} />
            </OKMessage>
        </div>
    ) : null;

    return (
        <div className="contract-loan-day-selector">
            <RadioButtonGroup
                label={radioButtonTitle}
                onChange={onPaymentDayChange}
                name="contract-loan-day-selector"
                idPrefix="contract-loan-day-selector"
                selectedValue={paymentDaySelected}
            >
                <RadioButton label={firstRadioButton} value={PAYMENT_DAY_END_OF_MONTH} />
                <RadioButton label={secondRadioButton} value={PAYMENT_DAY_OTHER} />
            </RadioButtonGroup>
            {messageContainer}
        </div>
    );
};

ContractLoanDaySelector.propTypes = {
    firstRadioButtonLabel: PropTypes.string.isRequired,
    message: PropTypes.string,
    onPaymentDayChange: PropTypes.func.isRequired,
    paymentDaySelected: PropTypes.string.isRequired,
    secondRadioButtonLabel: PropTypes.string.isRequired
};

module.exports = ContractLoanDaySelector;
